import { currentSongPlayerMuted } from "../../state/player";
import soundManager from "../soundManager";
import { soundKeys } from "./emoteKeys";

export function handleEmotes(emoteKey: (typeof soundKeys)[number]) {
  if (soundKeys.includes(emoteKey)) {
    if (currentSongPlayerMuted.value) {
      // Respect the muted state if the player is muted
      return;
    }
    soundManager.playSound(emoteKey);
  } else {
    console.warn(`Invalid emote key: ${emoteKey}`);
  }
}
